module.exports = ".error-message{color:red}"